import React, { useEffect, useState } from "react";
import {
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Paper,
    TableContainer,
    Typography,
    Divider,
    Card,
    CardHeader,
    CardContent,
    CircularProgress,
} from "@mui/material";


import {api} from "../../../../services/Main/Api";
import {getCondoId} from "../../../../services/Main/AuthStorage";

function formatCurrency(valueInCents) {
    const reais = valueInCents / 100;
    return reais.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
    });
}

const TransferDayTable = () => {
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const condoId = getCondoId()
    useEffect(() => {
        setIsLoading(true);

        api
            .get(`/analytics/payouts-by-day/?condo_id=${condoId}`)
            .then((response) => {
                setData(response?.data?.results || []);
            })
            .catch((error) => {
                console.error("Erro ao buscar repasses por dia:", error);
            })
            .finally(() => setIsLoading(false));
    }, []);

    return (
        <Card>
            <CardHeader title={'Previsão de repasses'} />
            <Divider />
            <CardContent>
                <TableContainer>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell align={"center"} sx={{color:"primary.main"}}><strong>Dia do Repasse</strong></TableCell>

                                <TableCell align={"center"} sx={{color:"primary.main"}}><strong>PIX</strong></TableCell>
                                <TableCell align={"center"} sx={{color:"primary.main"}}><strong>TED</strong></TableCell>
                                <TableCell align={"center"} sx={{color:"primary.main"}}><strong>Total</strong></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {isLoading ? (
                                <TableRow>
                                    <TableCell colSpan={3} align="center">
                                        <CircularProgress size={24} />
                                    </TableCell>
                                </TableRow>
                            ) : data.length > 0 ? (
                                data.map((row, index) => (
                                    <TableRow key={index}>
                                        <TableCell align={"center"}>{row.transfer_day_str}</TableCell>

                                        <TableCell align={"center"}>
                                            {formatCurrency(row.total_amount_pix)}
                                        </TableCell>
                                        <TableCell align={"center"}>
                                            {formatCurrency(row.total_amount_ted)}
                                        </TableCell>
                                        <TableCell align={"center"}>
                                            <strong>{formatCurrency(row.total_amount)}</strong>
                                        </TableCell>
                                    </TableRow>
                                ))
                            ) : (
                                <TableRow>
                                    <TableCell colSpan={3} align="center">
                                        Nenhum repasse encontrado.
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </CardContent>
        </Card>
    );
};

export default TransferDayTable;
